import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { toast } from "sonner";
import { useSite } from "../context/SiteContext";
import { useReferral } from "../context/ReferralContext";
import { openWhatsapp } from "../lib/whatsapp";

export function WhatsappButton({
  product,
  category,
  template,
  className = "",
  fullWidth = false,
  label = "Richiedi su WhatsApp",
  testId = "whatsapp-cta-button",
}) {
  const { settings } = useSite();
  const { referralCode, referralData } = useReferral();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const proceed = async () => {
    setLoading(true);
    const res = await openWhatsapp({
      number: settings.whatsapp_number,
      customerName: name.trim(),
      product,
      category,
      referralCode,
      discount: referralData?.discount_value,
      bonusType: referralData?.bonus_type,
      template,
    });
    setLoading(false);
    setOpen(false);
    if (!res.ok && res.reason === "no_number") {
      toast.error("Numero WhatsApp non ancora configurato dall'amministratore.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error("Inserisci il tuo nome per continuare.");
      return;
    }
    proceed();
  };

  return (
    <>
      <button
        data-testid={testId}
        onClick={() => setOpen(true)}
        className={`inline-flex items-center justify-center gap-2 bg-wa hover:bg-wa-dark text-white font-bold rounded-full px-5 py-3 text-sm transition-colors shadow-lg hover:shadow-xl disabled:opacity-60 ${
          fullWidth ? "w-full" : ""
        } ${className}`}
      >
        <MessageCircle className="w-4 h-4" />
        {label}
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-ink/60 backdrop-blur-sm animate-fade-in"
          data-testid="whatsapp-name-modal"
        >
          <div className="relative w-full max-w-sm bg-white rounded-2xl overflow-hidden soft-shadow-lg animate-scale-in">
            <div className="h-1.5 w-full bg-wa" />
            <button
              onClick={() => setOpen(false)}
              data-testid="whatsapp-name-close"
              className="absolute top-4 right-4 text-navy-soft hover:text-navy transition-colors"
              aria-label="Chiudi"
            >
              <X className="w-5 h-5" />
            </button>
            <form onSubmit={handleSubmit} className="p-7">
              <div className="w-12 h-12 rounded-2xl bg-wa/15 text-wa-dark flex items-center justify-center mb-5">
                <MessageCircle className="w-6 h-6" />
              </div>
              <h3 className="font-heading font-bold text-xl text-navy">Come ti chiami?</h3>
              <p className="mt-1.5 text-sm text-navy-soft">
                Inserisci il tuo nome: lo aggiungiamo al messaggio per {product ? `"${product}"` : "la tua richiesta"}.
              </p>
              <input
                autoFocus
                value={name}
                onChange={(e) => setName(e.target.value)}
                data-testid="whatsapp-name-input"
                placeholder="Nome e cognome"
                className="mt-5 w-full bg-surface border border-line focus:border-wa rounded-xl px-4 py-3 outline-none transition-colors text-navy"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="whatsapp-name-submit"
                className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-wa hover:bg-wa-dark text-white font-bold rounded-full py-3 transition-colors disabled:opacity-60 soft-shadow"
              >
                <MessageCircle className="w-4 h-4" />
                {loading ? "Apertura…" : "Continua su WhatsApp"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
